import { format } from 'date-fns';
import { I18N_KEYS } from '@/language/keys';
import { roundToDecimalIfNotWhole } from '@/utils/numbers';
import type { TFunction } from 'i18next';

/** Builds the promotion tooltip ("Costs X credits [until <date>]. Afterward, will cost Y credits."). */
export const getPromoTooltipTitle = (t: TFunction, price: number, fullPrice: number, expiresAt?: string): string => {
  const values = { price: roundToDecimalIfNotWhole(price), original: roundToDecimalIfNotWhole(fullPrice) };
  return expiresAt
    ? t(I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.PROMO_TOOLTIP_UNTIL, {
        ...values,
        date: format(new Date(expiresAt), 'MMM d'),
      })
    : t(I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.PROMO_TOOLTIP, values);
};

/** Builds the inline promo badge ("X% off [until <date>]"), or null when there's no active discount. */
export const getPromoBadgeText = (
  t: TFunction,
  price: number | null | undefined,
  fullPrice: number | null | undefined,
  expiresAt?: string,
): string | null => {
  if (price == null || fullPrice == null || fullPrice <= price) {
    return null;
  }
  const percent = Math.round((1 - price / fullPrice) * 100);
  if (percent < 1) {
    return null;
  }
  return expiresAt
    ? t(I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.PROMO_BADGE_UNTIL, {
        percent,
        date: format(new Date(expiresAt), 'MMMM d, yyyy'),
      })
    : t(I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.PROMO_BADGE, { percent });
};
